import * as yup from 'yup'

export const schemaWebhook = yup.object().shape({
  urlNotificationDefaultInvoices: yup.string().url(),
  urlNotificationDefaultContract: yup.string().url(),
})

export default schemaWebhook
